module.exports = __webpack_public_path__ + "static/media/anvish_sengupta.09971f7c.png";